module.exports = __webpack_public_path__ + "static/media/left.ccedb829.svg";